export const getDoctorAvailabilityList = (store) =>
  store.DoctorAvailability.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.DoctorAvailability;
  return rest;
};
export const getDoctorList = (store) => store.DoctorAvailability.filters.doctor;
export const getAreaList = (store) => store.DoctorAvailability.filters.area;
export const getWeekDayList = (store) => store.DoctorAvailability.filters.weekDay;
